import React, { useEffect, useRef, useState } from 'react';
import { getCountryOnBasisOfUrl } from '../../../Utils/ForeignUtils';
import { getScreenName, getUserIsLoggedIn } from '../../../Utils/helper';
import { UAECountryCode } from '../../AddressPage/constant';
import { assessmentText } from '../../QnaPage/AssessmentStrip/instrumentation';
import {
  CountryCode,
  FloatInput,
  FloatLabelDiv,
  MobileFloatLabel,
} from '../ClinicListingPage/ClinicCallbackOption/styled';
import { validationHandler } from '../HealthPlan/common';
import { ErrorTextStyle } from '../HealthPlan/styled';
import EnterOtp from '../../LoginModule/NewLoginModule/EnterOtp';
import { sendSmsMobile } from '../../../datafetchers/LoginPopup/sendSmsMobile';
import { removeCountryCode } from '../../LoginModule/NewLoginModule/common';
import GetOtpButton from '../../LoginModule/NewLoginModule/GetOtpButton';
import Cookies from 'js-cookie';
import { fireEvent } from '../../../Utils/fireEvent';

export default function TextInputField(props) {
  const {
    element,
    inputFieldErrorHandler,
    index,
    fromPdp,
    setEnabledButton,
    otpRequested,
    setOtpRequested,
    submitHandler,
    currentQuestionAnswer = '',
    inAppForm,
  } = props;
  element['error_text'] = `Please enter ${
    element?.validation_type == '2' ? 'valid phone number' : 'valid username'
  }`;
  const [userEnteredValue, setUserEnteredValue] = useState(
    currentQuestionAnswer,
  );
  const [verifyOtpScreen, setVerifyOtpScreen] = useState(false);
  const [isDifferentNumber, setIsDifferentNumber] = useState(false);
  const [hashedValue, setHashedValue] = useState();
  const [otpTries, setOtpTries] = useState(0);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [showOtpToast, setShowOtpToast] = useState(false);
  const apiCallTime = useRef();
  const mobileNumber = useRef();
  const handler = (e) => {
    const x = element.validation_type == '2';
    mobileNumber.current = e.target.value;
    let value = mobileNumber.current;

    const shouldValidate =
      validationHandler(element?.validation_type, value, isUae) && value != '';
    if (shouldValidate) inputFieldErrorHandler(value, index);
    else {
      inputFieldErrorHandler(value, index, true);
    }
    if (x) {
      mobileNumber.current = removeCountryCode(e.target.value);
      value = mobileNumber.current.replace(/[^0-9]/g, '');
      if (element?.validation_type == 2) {
        if (mobileNumber.current.length === 10) {
          if (new RegExp('[6-9]{1}[0-9]{9}').test(e.target.value)) {
            setDisableSendButton(false);
            inputFieldErrorHandler(e.target.value, index, otpRequested);
          }
          if (getUserIsLoggedIn()) {
            const data = Cookies.get('react_user_properties');
            const mobile = JSON.parse(data).mobile;
            if (mobileNumber.current != mobile) {
              setIsDifferentNumber(true);
              setEnabledButton(false);
            } else setIsDifferentNumber(false);
          }
        } else {
          setDisableSendButton(true);
        }
      }
    }
    setUserEnteredValue(value);
  };
  useEffect(() => {
    let data = Cookies.get('react_user_properties');
    if (data) {
      data = JSON.parse(data);
    }
    const mobile = data?.mobile;
    if (!mobile) return;
    mobileNumber.current = removeCountryCode(mobile);
    if (getUserIsLoggedIn() && element?.validation_type == 2) {
      setUserEnteredValue(mobileNumber.current);
      const shouldValidate =
        validationHandler(
          element?.validation_type,
          mobileNumber.current,
          isUae,
        ) && mobileNumber.current != '';
      if (shouldValidate) {
        inputFieldErrorHandler(mobileNumber.current, index);
        setOtpRequested(false);
      } else {
        inputFieldErrorHandler(mobileNumber.current, index, true);
      }

      if (mobileNumber.current != mobile) {
        setIsDifferentNumber(true);
      } else setIsDifferentNumber(false);
    }
  }, []);
  const isUae = getCountryOnBasisOfUrl() === 'UAE';
  const fireInputEvent = (event, element) => {
    if (!inAppForm) {
      let value = event?.target.value;
      if (isUae && element?.validation_type == 2)
        value = UAECountryCode + value;
      if (event?.target.value != '') {
        fireEvent({
          category: 'entered_data',
          screen_name: getScreenName(),
          sku_type: assessmentText,
          page_url: typeof window != 'undefined' ? window.location.href : 'NA',
          parent: assessmentText,
          name: element?.question_text,
          value: value,
        });
      }
    }
  };
  useEffect(() => {
    const inputEle = document.getElementById(
      element?.validation_type == 2 ? 'contact' : `name${index}`,
    );
    if (!verifyOtpScreen) inputEle?.focus();
  }, [verifyOtpScreen]);

  const getMobileNumber = () => {
    return { mobile: mobileNumber.current };
  };

  const sendOtp = async () => {
    const data = getMobileNumber();
    const response = await sendSmsMobile(data);
    // apiEvent("api/sendSMS");
    setOtpTries(0);
    if (response?.success) {
      setHashedValue(response.data);
      setVerifyOtpScreen(true);
      apiCallTime.current = new Date();
    }
  };
  return (
    <>
      {element?.validation_type == 2 ? (
        <FloatLabelDiv>
          {isUae ? (
            <>
              <CountryCode>{UAECountryCode}</CountryCode>
              <FloatInput
                clinic={true}
                autoFocus={index == 0 ? true : false}
                type="number"
                placeholder={element?.question_text}
                id="contact"
                onChange={(event) => handler(event)}
                // pattern="[1-9]{1}[0-9]{9}"
                maxLength={14}
                required={element?.required == 1 ? true : false}
                onBlur={(event) => {
                  fireInputEvent(event, element);
                }}
                inputmode={'numeric'}
                isNumeric={element?.validation_type == 2}
              />
              <MobileFloatLabel
                htmlFor=""
                dynamic
                isNumeric={element?.validation_type == 2}
              >
                {element?.question_text}
              </MobileFloatLabel>
            </>
          ) : (
            <>
              <h2>
                {verifyOtpScreen
                  ? 'Please verify your mobile.'
                  : element?.question_text}
              </h2>

              <>
                <FloatInput
                  clinic={true}
                  autoFocus={index == 0 ? true : false}
                  type="tel"
                  placeholder={element?.question_text}
                  id="contact"
                  onChange={(event) => handler(event)}
                  pattern="[1-9]{1}[0-9]{9}"
                  maxLength="10"
                  required={element?.required == 1 ? true : false}
                  onBlur={(event) => {
                    fireInputEvent(event, element);
                  }}
                  value={userEnteredValue}
                  disabled={verifyOtpScreen}
                />
                <ErrorTextStyle>
                  {!validationHandler(
                    element?.validation_type,
                    userEnteredValue,
                    isUae,
                  ) && userEnteredValue != ''
                    ? element?.error_text
                    : null}
                </ErrorTextStyle>
                {((getUserIsLoggedIn() && isDifferentNumber) ||
                  !getUserIsLoggedIn()) &&
                !verifyOtpScreen ? (
                  <GetOtpButton
                    disableSendButton={disableSendButton}
                    sendOtp={sendOtp}
                    fromConsult={true}
                  />
                ) : null}
                {verifyOtpScreen ? (
                  <EnterOtp
                    hashedValue={hashedValue}
                    mobileNumber={mobileNumber}
                    apiCallTime={apiCallTime}
                    sendOtp={sendOtp}
                    setVerifyOtpScreen={setVerifyOtpScreen}
                    fromAddress={false}
                    fromOrder={false}
                    setOtpTries={setOtpTries}
                    otpTries={otpTries}
                    setOtpRequested={setOtpRequested}
                    fromConsult={true}
                    setShowToast={setShowOtpToast}
                    setEnabledButton={setEnabledButton}
                    setIsDifferentNumber={setIsDifferentNumber}
                    submitHandler={submitHandler}
                    showOldLogin={true}
                  />
                ) : null}
              </>
            </>
          )}
        </FloatLabelDiv>
      ) : (
        <>
          <FloatLabelDiv>
            <h2>{element?.question_text}</h2>
            <FloatInput
              autoFocus={index == 0 ? true : false}
              clinic={true}
              type="text"
              placeholder={element?.question_text}
              id={`name${index}`}
              onChange={(event) => {
                handler(event);
              }}
              required={element?.required == 1 ? true : false}
              onBlur={(event) => {
                fireInputEvent(event, element);
              }}
              value={userEnteredValue}
            />
            {/* <MobileFloatLabel htmlFor="" dynamic>
                        {element?.question_text}
                    </MobileFloatLabel> */}
          </FloatLabelDiv>
        </>
      )}
      {element?.validation_type != 2 && (
        <ErrorTextStyle>
          {!validationHandler(
            element?.validation_type,
            userEnteredValue,
            isUae,
          ) && userEnteredValue != ''
            ? element?.error_text
            : null}
        </ErrorTextStyle>
      )}
    </>
  );
}
